export default __webpack_public_path__ + "static/media/help18.7b37f2ef.png";